import { add } from "./base";
class Handler {
    country;
    constructor(country) {
        this.country = country;
    }
    toString(data) {
        return typeof data == "string" ? data : "";
    }
    fromString(value) {
        return typeof value == "string" && !!value ? value : undefined;
    }
    partialFormat = this.format;
    format(unformatted) {
        let result = unformatted;
        const year = new Date().getFullYear().toString();
        if (unformatted.value.length > 1 && unformatted.get(0, 2) != "19" && unformatted.get(0, 2) != "20")
            result = result.prepend(unformatted.get(0, 2) > year.substring(2, 4) ? "19" : "20");
        if (result.value.length >= 8)
            result = result.insert(8, "-");
        return {
            ...result.truncate(13),
            type: "text",
            length: [11, 13],
            pattern: /^\d{6,8}-\d{4}$/,
        };
    }
    unformat(formatted) {
        return formatted.delete("-");
    }
    allowed(symbol, state) {
        return state.value.length < 13 && symbol >= "0" && symbol <= "9";
    }
}
add("identity-number", (argument) => new Handler(argument && argument.length > 0 ? argument[0] : undefined));
//# sourceMappingURL=identity-number.js.map